module.exports = __webpack_public_path__ + "img/border-service-item.jpg?eb990170519014662b747a3068ee8631";